import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaAngleRight, FaUserFriends, FaWallet } from "react-icons/fa";
import { FiLogOut, FiSettings } from "react-icons/fi";
import { MdDashboard, MdDeleteSweep, MdOutlineRequestQuote } from "react-icons/md";
import { HiOutlineMenu, HiMenu } from "react-icons/hi";

const SideNavBar = ({
  setOpenPage,
  isCollapsed,
  toggleSidebar,
  setIsCollapsed,
}) => {
  const navigate = useNavigate();
  const [active, setActive] = useState("");
  const menuSectionRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);
  const UserName = localStorage.getItem("UserName");



  useEffect(() => {
    const handleMouseEnter = () => {
      if (isCollapsed) {
        setIsHovered(true);
        setIsCollapsed(false);
      }
    };

    const handleMouseLeave = () => {
      if (isHovered) {
        setIsHovered(false);
        setIsCollapsed(true);
      }
    };

    const menuSection = menuSectionRef.current;
    if (menuSection) {
      menuSection.addEventListener("mouseenter", handleMouseEnter);
      menuSection.addEventListener("mouseleave", handleMouseLeave);
    }

    return () => {
      if (menuSection) {
        menuSection.removeEventListener("mouseenter", handleMouseEnter);
        menuSection.removeEventListener("mouseleave", handleMouseLeave);
      }
    };
  }, [isCollapsed, isHovered, setIsCollapsed]);

  const handleLogout = () => {
    localStorage.removeItem("authToken"); // Delete Tocken
    navigate("/login"); 
  };

  return (
    <div
      className={`fixed top-0 left-0 bg-gray-900 h-screen flex flex-col transition-all duration-300 ease-in-out z-50 ${
        isCollapsed && !isHovered ? "w-[3.6rem]" : "w-[13.9rem]"
      }`}
    >
      {/* Header */}
      <div
        className={`px-2 border-b py-3 border-gray-700 flex ${
          isCollapsed && !isHovered ? "justify-center" : "justify-between"
        } items-center`}
      >
        {(!isCollapsed || isHovered) && (
          <div className="flex items-center gap-1 overflow-hidden">
            <img
              src="/Heshe-Dashboard-logo.png"
              className="w-7 h-7  shrink-0"
              alt="Profile"
            />
            <p className="text-white whitespace-nowrap transition-all duration-300 ease-in-out " style={{ fontSize: "12px" }}>
              {UserName || "HeShe"}
            </p>
          </div>
        )}
        <button
          onClick={toggleSidebar}
          className="text-white p-2 rounded-md hover:bg-gray-700 transition-colors shrink-0"
        >
          {isCollapsed && !isHovered ? (
            <HiMenu className="text-2xl" />
          ) : (
            <HiOutlineMenu className="text-2xl" />
          )}
        </button>
      </div>

      {/* Menu Section */}
      <div
        ref={menuSectionRef}
        className={`flex flex-col p-2 text-white overflow-y-auto h-[83vh] [&::-webkit-scrollbar]:w-2
        [&::-webkit-scrollbar-track]:bg-gray-900
        [&::-webkit-scrollbar-thumb]:bg-gray-900
        dark:[&::-webkit-scrollbar-track]:bg-gray-900
        dark:[&::-webkit-scrollbar-thumb]:bg-neutral-500`}
      >
        {/* Dashboard */}
        <Link
          to="/dashboard"
          className={`flex ${
            isCollapsed && !isHovered ? "justify-center" : "justify-between"
          } items-center p-2 rounded-[2px] mb-2 ${
            active === "dashboard" ? "bg-blue-800" : "bg-gray-800"
          } transition-colors`}
          title={isCollapsed && !isHovered ? "Dashboard" : ""}
          onClick={() => {
            setActive("dashboard");
            setOpenPage("dashboard");
          }}
        >
          <div className="flex items-center gap-3 overflow-hidden">
            <MdDashboard className="text-xl shrink-0" />
            {(!isCollapsed || isHovered) && (
              <p className="text-white text-[15px]">Dashboard</p>
            )}
          </div>
          {(!isCollapsed || isHovered) && <FaAngleRight className="shrink-0" />}
        </Link>

        {/* User Details */}
        <Link
          to="/user-details"
          className={`flex ${
            isCollapsed && !isHovered ? "justify-center" : "justify-between"
          } items-center p-2 rounded-[2px] mb-2 ${
            active === "user details" ? "bg-blue-800" : "bg-gray-800"
          } transition-colors`}
          title={isCollapsed && !isHovered ? "user details" : ""}
          onClick={() => {
            setActive("user details");
            setOpenPage("user details");
            
          }}
        >
          <div className="flex items-center gap-3 overflow-hidden">
            <FaUserFriends className="text-xl shrink-0" />
            {(!isCollapsed || isHovered) && (
              <p className="text-white text-[15px]">User Details</p>
            )}
          </div>
          {(!isCollapsed || isHovered) && <FaAngleRight className="shrink-0" />}
        </Link>

        {/* Wallet Data */}
        <Link
          to="/wallet-data"
          className={`flex ${
            isCollapsed && !isHovered ? "justify-center" : "justify-between"
          } items-center p-2 rounded-[2px] mb-2 ${
            active === "wallet data" ? "bg-blue-800" : "bg-gray-800"
          } transition-colors`}
          title={isCollapsed && !isHovered ? "wallet data" : ""}
          onClick={() => {
            setActive("wallet data");
            setOpenPage("wallet data");
          }}
        >
          <div className="flex items-center gap-3 overflow-hidden">
            <FaWallet className="text-xl shrink-0" />
            {(!isCollapsed || isHovered) && (
              <p className="text-white text-[15px]">Wallet Data</p>
            )}
          </div>
          {(!isCollapsed || isHovered) && <FaAngleRight className="shrink-0" />}
        </Link>

        {/* Refund Request */}
        <Link
          to="/refund-request"
          className={`flex ${
            isCollapsed && !isHovered ? "justify-center" : "justify-between"
          } items-center p-2 rounded-[2px] mb-2 ${
            active === "refund request" ? "bg-blue-800" : "bg-gray-800"
          } transition-colors`}
          title={isCollapsed && !isHovered ? "refund request" : ""}
          onClick={() => {
            setActive("refund request");
            setOpenPage("refund request");
          }}
        >
          <div className="flex items-center gap-3 overflow-hidden">
            <MdOutlineRequestQuote className="text-xl shrink-0" />
            {(!isCollapsed || isHovered) && (
              <p className="text-white text-[15px]">Refund Request</p>
            )}
          </div>
          {(!isCollapsed || isHovered) && <FaAngleRight className="shrink-0" />}
        </Link>
        

        {/* Config */}
        <Link
          to="/config"
          className={`flex ${
            isCollapsed && !isHovered ? "justify-center" : "justify-between"
          } items-center p-2 rounded-[2px] mb-2 ${
            active === "config" ? "bg-blue-800" : "bg-gray-800"
          } transition-colors`}
          title={isCollapsed && !isHovered ? "config" : ""}
          onClick={() => {
            setActive("config");
            setOpenPage("config");
          }}
        >
          <div className="flex items-center gap-3 overflow-hidden">
            <FiSettings className="text-xl shrink-0" />
            {(!isCollapsed || isHovered) && (
              <p className="text-white text-[15px]">Config</p>
            )}
          </div>
          {(!isCollapsed || isHovered) && <FaAngleRight className="shrink-0" />}
        </Link>

        
        <Link
          to="/coin-settings"
          className={`flex ${
            isCollapsed && !isHovered ? "justify-center" : "justify-between"
          } items-center p-2 rounded-[2px] mb-2 ${
            active === "coin settings" ? "bg-blue-800" : "bg-gray-800"
          } transition-colors`}
          title={isCollapsed && !isHovered ? "coin settings" : ""}
          onClick={() => {
            setActive("coin settings");
            setOpenPage("coin settings");
          }}
        >
          <div className="flex items-center gap-3 overflow-hidden">
            <FiSettings className="text-xl shrink-0" />
            {(!isCollapsed || isHovered) && (
              <p className="text-white text-[15px]">Coin Settings</p>
            )}
          </div>
          {(!isCollapsed || isHovered) && <FaAngleRight className="shrink-0" />}
        </Link>

        
        <Link
          to="/diamond-settings"
          className={`flex ${
            isCollapsed && !isHovered ? "justify-center" : "justify-between"
          } items-center p-2 rounded-[2px] mb-2 ${
            active === "diamond settings" ? "bg-blue-800" : "bg-gray-800"
          } transition-colors`}
          title={isCollapsed && !isHovered ? "diamond settings" : ""}
          onClick={() => {
            setActive("diamond settings");
            setOpenPage("diamond settings");
          }}
        >
          <div className="flex items-center gap-3 overflow-hidden">
            <FiSettings className="text-xl shrink-0" />
            {(!isCollapsed || isHovered) && (
              <p className="text-white text-[15px]">Diamond Settings</p>
            )}
          </div>
          {(!isCollapsed || isHovered) && <FaAngleRight className="shrink-0" />}
        </Link>

        <Link
          to="/task-settings"
          className={`flex ${
            isCollapsed && !isHovered ? "justify-center" : "justify-between"
          } items-center p-2 rounded-[2px] mb-2 ${
            active === "task settings" ? "bg-blue-800" : "bg-gray-800"
          } transition-colors`}
          title={isCollapsed && !isHovered ? "task settings" : ""}
          onClick={() => {
            setActive("task settings");
            setOpenPage("task settings");
          }}
        >
          <div className="flex items-center gap-3 overflow-hidden">
            <FiSettings className="text-xl shrink-0" />
            {(!isCollapsed || isHovered) && (
              <p className="text-white text-[15px]">Task Settings</p>
            )}
          </div>
          {(!isCollapsed || isHovered) && <FaAngleRight className="shrink-0" />}
        </Link>

        <Link
          to="/visitor-plan"
          className={`flex ${
            isCollapsed && !isHovered ? "justify-center" : "justify-between"
          } items-center p-2 rounded-[2px] mb-2 ${
            active === "visitor plan" ? "bg-blue-800" : "bg-gray-800"
          } transition-colors`}
          title={isCollapsed && !isHovered ? "visitor plan" : ""}
          onClick={() => {
            setActive("visitor plan");
            setOpenPage("visitor plan");
          }}
        >
          <div className="flex items-center gap-3 overflow-hidden">
            <FiSettings className="text-xl shrink-0" />
            {(!isCollapsed || isHovered) && (
              <p className="text-white text-[15px]">Visitor Plan</p>
            )}
          </div>
          {(!isCollapsed || isHovered) && <FaAngleRight className="shrink-0" />}
        </Link>

        
        <Link
          to="/blocked-users"
          className={`flex ${
            isCollapsed && !isHovered ? "justify-center" : "justify-between"
          } items-center p-2 rounded-[2px] mb-2 ${
            active === "blocked users" ? "bg-blue-800" : "bg-gray-800"
          } transition-colors`}
          title={isCollapsed && !isHovered ? "blocked users" : ""}
          onClick={() => {
            setActive("blocked users");
            setOpenPage("blocked users");
          }}
        >
          <div className="flex items-center gap-3 overflow-hidden">
            <MdDeleteSweep className="text-xl shrink-0" />
            {(!isCollapsed || isHovered) && (
              <p className="text-white text-[15px]">Blocked Users</p>
            )}
          </div>
          {(!isCollapsed || isHovered) && <FaAngleRight className="shrink-0" />}
        </Link>
      </div>

      {/* Footer */}
      <div className="mt-auto p-4 border-t border-gray-700">
        <div
          className={`flex ${
            isCollapsed && !isHovered ? "justify-center" : ""
          } items-center gap-3 text-white cursor-pointer hover:text-gray-300 transition-colors`}
          title={isCollapsed && !isHovered ? "Logout" : ""}
          onClick={handleLogout}
        >
          <FiLogOut className="shrink-0" />
          {(!isCollapsed || isHovered) && (
            <p className="whitespace-nowrap transition-all duration-300 ease-in-out">
              Logout
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default SideNavBar;
